import React from "react";
import { Styles } from "./styles";
import { Container, TabPane, Tabs } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import CrownImg from "../../../assets/images/backGrounds/crown.webp";
import { useMediaQuery } from "../../../helpers/useMediaQuery";
import i18next, { t } from "i18next";
import { useSelector } from "react-redux";
import { getLeaderboard } from "../../../services/student.service";
import { useEffect } from "react";
import { useState } from "react";
import Loader from "../../common/loader/Loader";
import { useRef } from "react";
import { Fade } from "react-reveal";
import environment from "../../../environment";
import Error from "../../common/error/Error";
import UserIAvatar from "../../../assets/images/icons/user.webp";

const ItemCard = ({ item, id, isMobile }) => {
  const isAr = i18next.language === "ar";

  return (
    <>
      <div className={id === 1 ? "item-img first-item" : "item-img"}>
        {item?.student?.avatar ? (
          <img src={item?.student?.avatar} alt="trainee image" />
        ) : (
          <img src={UserIAvatar} alt="trainee image" className="user-avatar" />
        )}
        {id === 1 && (
          <div className="item-crown">
            <img src={CrownImg} alt="crown image" />
          </div>
        )}
      </div>
      {!isMobile && <div className="item-ranking">{id}</div>}
      <div className="item-name">
        {isMobile && <>{id}. </>}
        {isAr ? item?.student?.fullNameAr : item?.student?.fullNameEn}
      </div>
    </>
  );
};

const LeaderBoards = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const coursesRef = useRef(null);
  const isLogin = localStorage.getItem(environment.TOKEN_KEY);

  const titleLength = isMobile ? 21 : 30;
  const descriptionLength = isMobile ? 21 : 30;

  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  const LeaderBoard = async () => {
    setIsLoading(true);
    const response = await getLeaderboard();
    if (response?.status === 200) {
      setData(response?.data?.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    isLogin && LeaderBoard();
  }, []);

  const [activeTab, setActiveTab] = useState(1);

  const handleNext = () => {
    if (activeTab + 2 <= data.length) {
      coursesRef.current.swiper.slideTo(activeTab + 1);
      setActiveTab(activeTab + 2);
    } else {
      coursesRef.current.swiper.slideTo(0);
      setActiveTab(1);
    }
  };

  const handlePrev = () => {
    if (activeTab === 1) {
      coursesRef.current.swiper.slideTo(data.length);
      setActiveTab(data.length);
    } else if (activeTab === 2) {
      coursesRef.current.swiper.slideTo(0);
      setActiveTab(1);
    } else if (activeTab - 2 >= 1) {
      coursesRef.current.swiper.slideTo(activeTab - 3);
      setActiveTab(activeTab - 2);
    }
  };

  return (
    <Styles>
      {isLoading ? (
        <Loader />
      ) : (
        data?.length > 0 && (
          <section id="leaderBoardsSection" className="mb-5">
            <Container>
              <Fade bottom>
                <h2 className="section-title">
                  {Resource?.leaderboards_title
                    ? Resource?.leaderboards_title
                    : t("home.leaderboards.title")}
                </h2>
              </Fade>

              <div className="leaderboard-container">
                <Swiper
                  ref={coursesRef}
                  onSlideChange={(swiper) => {
                    setActiveTab(swiper.activeIndex);
                  }}
                  slidesPerView={2}
                  spaceBetween={10}
                  allowTouchMove={false}
                  className={
                    data?.length > 2
                      ? "course-swiper"
                      : "course-swiper swiper-with-pages"
                  }
                >
                  {data?.map((item, idx) => (
                    <SwiperSlide key={idx}>
                      <Tabs
                        activeKey={activeTab}
                        onSelect={(index) => {
                          setActiveTab(parseInt(index));
                        }}
                      >
                        <TabPane
                          eventKey={++idx}
                          title={
                            <>
                              <div className="title">
                                {item?.localizedCourseName?.length >
                                titleLength ? (
                                  <>
                                    {item?.localizedCourseName.substring(
                                      0,
                                      titleLength
                                    )}
                                    ...
                                  </>
                                ) : (
                                  item?.localizedCourseName
                                )}
                              </div>
                              <div className="schedule-name">
                                {item?.localizedScheduleName?.length >
                                descriptionLength ? (
                                  <>
                                    {item?.localizedScheduleName.substring(
                                      0,
                                      descriptionLength
                                    )}
                                    ...
                                  </>
                                ) : (
                                  item?.localizedScheduleName
                                )}
                                {/* {item?.localizedScheduleName} */}
                              </div>
                            </>
                          }
                        ></TabPane>
                      </Tabs>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div style={{ display: "flex" }} className="leaderboards-data">
                  {data[activeTab - 1]?.studentsData?.length > 0 ? (
                    <>
                      {isMobile && data[activeTab - 1]?.studentsData[0] && (
                        <div className="leaderboards-data-item">
                          <ItemCard
                            item={data[activeTab - 1]?.studentsData[0]}
                            id={1}
                            isMobile={isMobile}
                          />
                        </div>
                      )}
                      <div className="leaderboards-data-item">
                        {data[activeTab - 1]?.studentsData[1] && (
                          <ItemCard
                            item={data[activeTab - 1]?.studentsData[1]}
                            id={2}
                            isMobile={isMobile}
                          />
                        )}
                      </div>
                      {!isMobile && data[activeTab - 1]?.studentsData[0] && (
                        <div className="leaderboards-data-item">
                          <ItemCard
                            item={data[activeTab - 1]?.studentsData[0]}
                            id={1}
                            isMobile={isMobile}
                          />
                        </div>
                      )}
                      <div className="leaderboards-data-item">
                        {data[activeTab - 1]?.studentsData[2] && (
                          <ItemCard
                            item={data[activeTab - 1]?.studentsData[2]}
                            id={3}
                            isMobile={isMobile}
                          />
                        )}
                      </div>
                    </>
                  ) : (
                    <Error message={t("no_data")} />
                  )}
                </div>
                {data?.length > 2 && (
                  <>
                    <button
                      className={
                        i18next?.language === "ar"
                          ? "btn-next"
                          : "btn-next btn-next-en"
                      }
                      onClick={handlePrev}
                    >
                      <i className="fa-solid fa-angle-left"></i>
                    </button>
                    <button
                      className={
                        i18next?.language === "ar"
                          ? "btn-prev"
                          : "btn-prev btn-prev-en"
                      }
                      onClick={handleNext}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </button>
                  </>
                )}
              </div>
            </Container>
          </section>
        )
      )}
    </Styles>
  );
};

export default LeaderBoards;
